import React from "react";
import { NestedRoute } from "../../components/shared/NestedRoute/NestedRoute";

export const Settings = () => {
  return <NestedRoute baseRoute="settings-sidebar" />;
};
